// This file is auto-generated from the translation JSON file
// Do not edit manually
// Use npm run generate-t7e instead!
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-explicit-any */
import i18next from 'i18next';
export const Keys = [
    'countries.AAT',
    'countries.ADG',
    'countries.AF',
    'countries.AG',
    'countries.AGUK',
    'countries.AM',
    'countries.ANTN',
    'countries.AO',
    'countries.AQ',
    'countries.AR',
    'countries.ARV',
    'countries.AT',
    'countries.AU',
    'countries.AZ',
    'countries.B',
    'countries.BASH',
    'countries.BAT',
    'countries.BB',
    'countries.BBUK',
    'countries.BD',
    'countries.BG',
    'countries.BGN',
    'countries.BM',
    'countries.BO',
    'countries.BR',
    'countries.BS',
    'countries.BT',
    'countries.BY',
    'countries.CA',
    'countries.CD',
    'countries.CH',
    'countries.CI',
    'countries.CK',
    'countries.CL',
    'countries.CM',
    'countries.CN',
    'countries.CO',
    'countries.COLP',
    'countries.CR',
    'countries.CSFR',
    'countries.CSSR',
    'countries.CU',
    'countries.CYM',
    'countries.CYMRU',
    'countries.CZ',
    'countries.D',
    'countries.DAG',
    'countries.DD',
    'countries.DJ',
    'countries.DK',
    'countries.DML',
    'countries.DR',
    'countries.DX',
    'countries.DZ',
    'countries.E',
    'countries.EC',
    'countries.EE',
    'countries.EG',
    'countries.ENG',
    'countries.ESCN',
    'countries.ET',
    'countries.F',
    'countries.FI',
    'countries.GE',
    'countries.GH',
    'countries.GI',
    'countries.GL',
    'countries.GR',
    'countries.GRD',
    'countries.GT',
    'countries.GU',
    'countries.GUF',
    'countries.HK',
    'countries.HKUK',
    'countries.HR',
    'countries.HU',
    'countries.I',
    'countries.I-ARAB',
    'countries.I-CSC1',
    'countries.I-ELDO',
    'countries.I-ESRO',
    'countries.I-EUM',
    'countries.I-EU',
    'countries.I-EUT',
    'countries.I-INM',
    'countries.I-INT',
    'countries.I-ISS',
    'countries.I-NATO',
    'countries.I-RASC',
    'countries.ID',
    'countries.IE',
    'countries.IL',
    'countries.IN',
    'countries.IQ',
    'countries.IR',
    'countries.IS',
    'countries.J',
    'countries.JO',
    'countries.KE',
    'countries.KI',
    'countries.KG',
    'countries.KGSR',
    'countries.KH',
    'countries.KORS',
    'countries.KORSA',
    'countries.KP',
    'countries.KR',
    'countries.KW',
    'countries.KZ',
    'countries.L',
    'countries.LA',
    'countries.LB',
    'countries.LK',
    'countries.LT',
    'countries.LV',
    'countries.LY',
    'countries.MA',
    'countries.MC',
    'countries.MD',
    'countries.MH',
    'countries.MN',
    'countries.MR',
    'countries.MU',
    'countries.MV',
    'countries.MX',
    'countries.MY',
    'countries.MYM',
    'countries.N',
    'countries.NG',
    'countries.NL',
    'countries.NP',
    'countries.NZ',
    'countries.NZRD',
    'countries.OM',
    'countries.P',
    'countries.PAR',
    'countries.PCZ',
    'countries.PE',
    'countries.PG',
    'countries.PK',
    'countries.PH',
    'countries.PL',
    'countries.PLRL',
    'countries.PR',
    'countries.PT',
    'countries.PY',
    'countries.QA',
    'countries.RO',
    'countries.RU',
    'countries.RW',
    'countries.S',
    'countries.SA',
    'countries.SCOT',
    'countries.SD',
    'countries.SG',
    'countries.SH',
    'countries.SI',
    'countries.SK',
    'countries.SR',
    'countries.SU',
    'countries.SY',
    'countries.T',
    'countries.TC',
    'countries.TF',
    'countries.TJ',
    'countries.TM',
    'countries.TN',
    'countries.TO',
    'countries.TR',
    'countries.TTPI',
    'countries.TUVA',
    'countries.TW',
    'countries.UA',
    'countries.UAE',
    'countries.UK',
    'countries.UM',
    'countries.US',
    'countries.UY',
    'countries.UZ',
    'countries.VE',
    'countries.VN',
    'countries.YE',
    'countries.ZA',
    'countries.ZR',
    'countries.ZW',
    'countries.ANALSAT',
    'countries.SAUD',
    'countries.AB',
    'countries.AC',
    'countries.ALG',
    'countries.ALL',
    'countries.ARGN',
    'countries.ASRA',
    'countries.AUS',
    'countries.AZER',
    'countries.BEL',
    'countries.BELA',
    'countries.BERM',
    'countries.BOL',
    'countries.BRAZ',
    'countries.CHBZ',
    'countries.CHLE',
    'countries.CIS',
    'countries.COL',
    'countries.CZCH',
    'countries.DEN',
    'countries.ECU',
    'countries.EGYP',
    'countries.ESA',
    'countries.I-ESA',
    'countries.EST',
    'countries.EUME',
    'countries.EUTE',
    'countries.FIN',
    'countries.FGER',
    'countries.FR',
    'countries.FRIT',
    'countries.GER',
    'countries.GLOB',
    'countries.GREC',
    'countries.HUN',
    'countries.IM',
    'countries.IND',
    'countries.INDO',
    'countries.IRAN',
    'countries.IRAQ',
    'countries.ISRA',
    'countries.ISS',
    'countries.IT',
    'countries.ITSO',
    'countries.JPN',
    'countries.KAZ',
    'countries.LAOS',
    'countries.LTU',
    'countries.LUXE',
    'countries.MALA',
    'countries.MEX',
    'countries.NATO',
    'countries.NETH',
    'countries.NICO',
    'countries.NIG',
    'countries.NKOR',
    'countries.NOR',
    'countries.O3B',
    'countries.ORB',
    'countries.PAKI',
    'countries.PERU',
    'countries.POL',
    'countries.POR',
    'countries.PRC',
    'countries.RASC',
    'countries.ROC',
    'countries.Taiwan',
    'countries.ROM',
    'countries.SAFR',
    'countries.SEAL',
    'countries.RP',
    'countries.SES',
    'countries.SING',
    'countries.SKOR',
    'countries.SN',
    'countries.SPN',
    'countries.STCT',
    'countries.SWED',
    'countries.SWTZ',
    'countries.THAI',
    'countries.TMMC',
    'countries.TURK',
    'countries.UKR',
    'countries.URY',
    'countries.USA',
    'countries.USBZ',
    'countries.VENZ',
    'countries.VTNM',
    'countries.TBD',
    'countries.BH',
    'countries.BW',
    'countries.ESA/JAXA',
    'plugins.proOnlyMsg',
    'plugins.SensorListPlugin.bottomIconLabel',
    'plugins.SensorListPlugin.title',
    'plugins.SensorListPlugin.helpBody',
    'plugins.SensorInfoPlugin.bottomIconLabel',
    'plugins.SensorInfoPlugin.title',
    'plugins.SensorInfoPlugin.helpBody',
    'plugins.CustomSensorPlugin.bottomIconLabel',
    'plugins.CustomSensorPlugin.title',
    'plugins.CustomSensorPlugin.helpBody',
    'plugins.LookAnglesPlugin.bottomIconLabel',
    'plugins.LookAnglesPlugin.title',
    'plugins.LookAnglesPlugin.helpBody',
    'plugins.MultiSiteLookAnglesPlugin.bottomIconLabel',
    'plugins.MultiSiteLookAnglesPlugin.title',
    'plugins.MultiSiteLookAnglesPlugin.helpBody',
    'plugins.SensorTimeline.bottomIconLabel',
    'plugins.SensorTimeline.title',
    'plugins.SensorTimeline.helpBody',
    'plugins.ProximityOps.bottomIconLabel',
    'plugins.ProximityOps.title',
    'plugins.ProximityOps.titleSecondary',
    'plugins.ProximityOps.helpBody',
    'plugins.ProximityOps.noradId',
    'plugins.ProximityOps.maxDistThreshold',
    'plugins.ProximityOps.maxRelativeVelocity',
    'plugins.ProximityOps.searchDuration',
    'plugins.ProximityOps.geoText',
    'plugins.ProximityOps.leoText',
    'plugins.ProximityOps.orbitType',
    'plugins.ProximityOps.geoAllVsAll',
    'plugins.ProximityOps.geoAllVsAllTooltip',
    'plugins.ProximityOps.comparePayloadsOnly',
    'plugins.ProximityOps.comparePayloadsOnlyTooltip',
    'plugins.ProximityOps.ignoreVimpelRso',
    'plugins.ProximityOps.ignoreVimpelRsoTooltip',
    'plugins.SatelliteTimeline.bottomIconLabel',
    'plugins.SatelliteTimeline.title',
    'plugins.SatelliteTimeline.helpBody',
    'plugins.WatchlistPlugin.bottomIconLabel',
    'plugins.WatchlistPlugin.title',
    'plugins.WatchlistPlugin.helpBody',
    'plugins.WatchlistOverlay.bottomIconLabel',
    'plugins.WatchlistOverlay.title',
    'plugins.WatchlistOverlay.helpBody',
    'plugins.ReportsPlugin.bottomIconLabel',
    'plugins.ReportsPlugin.title',
    'plugins.ReportsPlugin.helpBody',
    'plugins.PolarPlotPlugin.bottomIconLabel',
    'plugins.PolarPlotPlugin.title',
    'plugins.PolarPlotPlugin.helpBody',
    'plugins.NextLaunchesPlugin.bottomIconLabel',
    'plugins.NextLaunchesPlugin.title',
    'plugins.NextLaunchesPlugin.helpBody',
    'plugins.FindSatPlugin.bottomIconLabel',
    'plugins.FindSatPlugin.title',
    'plugins.FindSatPlugin.helpBody',
    'plugins.ShortTermFences.bottomIconLabel',
    'plugins.ShortTermFences.title',
    'plugins.ShortTermFences.helpBody',
    'plugins.Collisions.bottomIconLabel',
    'plugins.Collisions.title',
    'plugins.Collisions.helpBody',
    'plugins.TrackingImpactPredict.bottomIconLabel',
    'plugins.TrackingImpactPredict.title',
    'plugins.TrackingImpactPredict.helpBody',
    'plugins.Breakup.bottomIconLabel',
    'plugins.Breakup.title',
    'plugins.Breakup.helpBody',
    'plugins.DebrisScreening.bottomIconLabel',
    'plugins.DebrisScreening.title',
    'plugins.DebrisScreening.helpBody',
    'plugins.TransponderChannelData.bottomIconLabel',
    'plugins.TransponderChannelData.title',
    'plugins.TransponderChannelData.helpBody',
    'plugins.EditSat.bottomIconLabel',
    'plugins.EditSat.title',
    'plugins.EditSat.helpBody',
    'plugins.NewLaunch.bottomIconLabel',
    'plugins.NewLaunch.title',
    'plugins.NewLaunch.helpBody',
    'plugins.MissilePlugin.bottomIconLabel',
    'plugins.MissilePlugin.title',
    'plugins.MissilePlugin.helpBody',
    'plugins.StereoMap.bottomIconLabel',
    'plugins.StereoMap.title',
    'plugins.StereoMap.helpBody',
    'plugins.SensorFov.bottomIconLabel',
    'plugins.SensorSurvFence.bottomIconLabel',
    'plugins.SatelliteViewPlugin.bottomIconLabel',
    'plugins.SatelliteFov.bottomIconLabel',
    'plugins.SatelliteFov.title',
    'plugins.SatelliteFov.helpBody',
    'plugins.Planetarium.bottomIconLabel',
    'plugins.NightToggle.bottomIconLabel',
    'plugins.SatConstellations.bottomIconLabel',
    'plugins.SatConstellations.title',
    'plugins.SatConstellations.helpBody',
    'plugins.CountriesMenu.bottomIconLabel',
    'plugins.CountriesMenu.title',
    'plugins.CountriesMenu.helpBody',
    'plugins.ColorMenu.bottomIconLabel',
    'plugins.ColorMenu.title',
    'plugins.ColorMenu.helpBody',
    'plugins.Screenshot.bottomIconLabel',
    'plugins.LaunchCalendar.bottomIconLabel',
    'plugins.TimeMachine.bottomIconLabel',
    'plugins.SatellitePhotos.bottomIconLabel',
    'plugins.SatellitePhotos.title',
    'plugins.SatellitePhotos.helpBody',
    'plugins.ScreenRecorder.bottomIconLabel',
    'plugins.Astronomy.bottomIconLabel',
    'plugins.Calculator.bottomIconLabel',
    'plugins.Calculator.title',
    'plugins.Calculator.helpBody',
    'plugins.ManeuverPlugin.bottomIconLabel',
    'plugins.ManeuverPlugin.title',
    'plugins.ManeuverPlugin.helpBody',
    'plugins.AnalysisMenu.bottomIconLabel',
    'plugins.AnalysisMenu.title',
    'plugins.AnalysisMenu.helpBody',
    'plugins.SettingsMenuPlugin.bottomIconLabel',
    'plugins.SettingsMenuPlugin.title',
    'plugins.SettingsMenuPlugin.helpBody',
    'plugins.VideoDirectorPlugin.title',
    'plugins.VideoDirectorPlugin.bottomIconLabel',
    'plugins.VideoDirectorPlugin.helpBody',
    'plugins.CreateSat.bottomIconLabel',
    'plugins.CreateSat.title',
    'plugins.CreateSat.helpBody',
    'plugins.DopsPlugin.bottomIconLabel',
    'plugins.DopsPlugin.title',
    'plugins.DopsPlugin.helpBody',
    'plugins.EciPlot.bottomIconLabel',
    'plugins.EciPlot.title',
    'plugins.EciPlot.helpBody',
    'plugins.EcfPlot.bottomIconLabel',
    'plugins.EcfPlot.title',
    'plugins.EcfPlot.helpBody',
    'plugins.RicPlot.bottomIconLabel',
    'plugins.RicPlot.title',
    'plugins.RicPlot.helpBody',
    'plugins.Time2LonPlots.bottomIconLabel',
    'plugins.Time2LonPlots.title',
    'plugins.Time2LonPlots.helpBody',
    'plugins.Lat2LonPlots.bottomIconLabel',
    'plugins.Lat2LonPlots.title',
    'plugins.Lat2LonPlots.helpBody',
    'plugins.Inc2AltPlots.bottomIconLabel',
    'plugins.Inc2AltPlots.title',
    'plugins.Inc2AltPlots.helpBody',
    'plugins.Inc2LonPlots.bottomIconLabel',
    'plugins.Inc2LonPlots.title',
    'plugins.Inc2LonPlots.helpBody',
    'plugins.GraphicsMenuPlugin.bottomIconLabel',
    'plugins.GraphicsMenuPlugin.title',
    'plugins.GraphicsMenuPlugin.helpBody',
    'plugins.FilterMenuPlugin.title',
    'plugins.FilterMenuPlugin.bottomIconLabel',
    'plugins.FilterMenuPlugin.helpBody',
    'plugins.OrbitGuardMenuPlugin.bottomIconLabel',
    'plugins.OrbitGuardMenuPlugin.title',
    'plugins.OrbitGuardMenuPlugin.helpBody',
    'plugins.PlanetsMenuPlugin.bottomIconLabel',
    'plugins.PlanetsMenuPlugin.title',
    'plugins.PlanetsMenuPlugin.helpBody',
    'plugins.ScenarioManagementPlugin.title',
    'plugins.ScenarioManagementPlugin.bottomIconLabel',
    'plugins.ScenarioManagementPlugin.helpBody',
    'plugins.DebugMenuPlugin.bottomIconLabel',
    'plugins.DebugMenuPlugin.title',
    'plugins.DebugMenuPlugin.helpBody',
    'plugins.OemReaderPlugin.title',
    'plugins.OemReaderPlugin.bottomIconLabel',
    'plugins.OemReaderPlugin.helpBody',
    'plugins.OemReaderPlugin.loadOemFile',
    'plugins.OemReaderPlugin.fileLoadedSuccess',
    'plugins.OemReaderPlugin.fileLoadedError',
    'plugins.OemReaderPlugin.centerBody',
    'plugins.OemReaderPlugin.earth',
    'plugins.OemReaderPlugin.moon',
    'plugins.OemReaderPlugin.satelliteModel',
    'plugins.OemReaderPlugin.drawOrbitPath',
    'splashScreens.1',
    'splashScreens.2',
    'splashScreens.3',
    'splashScreens.4',
    'splashScreens.5',
    'splashScreens.6',
    'splashScreens.7',
    'splashScreens.8',
    'splashScreens.9',
    'splashScreens.10',
    'splashScreens.11',
    'splashScreens.12',
    'splashScreens.13',
    'splashScreens.14',
    'splashScreens.15',
    'splashScreens.16',
    'splashScreens.17',
    'splashScreens.18',
    'splashScreens.19',
    'splashScreens.20',
    'splashScreens.21',
    'splashScreens.22',
    'splashScreens.23',
    'splashScreens.24',
    'splashScreens.25',
    'splashScreens.26',
    'splashScreens.27',
    'splashScreens.28',
    'splashScreens.29',
    'loadingScreenMsgs.math',
    'loadingScreenMsgs.science',
    'loadingScreenMsgs.science2',
    'loadingScreenMsgs.dots',
    'loadingScreenMsgs.satIntel',
    'loadingScreenMsgs.painting',
    'loadingScreenMsgs.coloring',
    'loadingScreenMsgs.elsets',
    'loadingScreenMsgs.models',
    'loadingScreenMsgs.cunningPlan',
    'copyright.notice',
    'copyright.noticeMobile',
    'Common.unknown',
    'loadingScreen.startButton',
    'time.days.0',
    'time.days.1',
    'time.days.2',
    'time.days.3',
    'time.days.4',
    'time.days.5',
    'time.days.6',
    'time.days-short.0',
    'time.days-short.1',
    'time.days-short.2',
    'time.days-short.3',
    'time.days-short.4',
    'time.days-short.5',
    'time.days-short.6',
    'time.months.1',
    'time.months.2',
    'time.months.3',
    'time.months.4',
    'time.months.5',
    'time.months.6',
    'time.months.7',
    'time.months.8',
    'time.months.9',
    'time.months.10',
    'time.months.11',
    'time.months.12',
    'time.calendar.time',
    'time.calendar.hour',
    'time.calendar.minute',
    'time.calendar.second',
    'time.calendar.now',
    'time.calendar.done',
    'time.calendar.pause',
    'time.calendar.propagation',
    'errorMsgs.catalogNotFullyInitialized',
    'errorMsgs.sensorGroupsApiEmpty',
    'errorMsgs.SelectSensorFirst',
    'errorMsgs.SelectSatelliteFirst',
    'errorMsgs.SelectSecondarySatellite',
    'errorMsgs.SatelliteNotDetailedSatellite',
    'errorMsgs.SensorNotFound',
    'errorMsgs.Scene.disablingGodrays',
    'errorMsgs.Scene.disablingAurora',
    'errorMsgs.Scene.disablingAtmosphere',
    'errorMsgs.Scene.disablingMoon',
    'errorMsgs.Scene.disablingMilkyWay',
    'errorMsgs.Scene.disablingSun',
    'errorMsgs.Breakup.SatelliteNotFound',
    'errorMsgs.Breakup.CannotCreateBreakupForNonCircularOrbits',
    'errorMsgs.Breakup.CannotCalcDirectionOfSatellite',
    'errorMsgs.Breakup.ErrorCreatingBreakup',
    'errorMsgs.Breakup.InvalidStartNum',
    'errorMsgs.Breakup.BreakupGeneratorFailed',
    'errorMsgs.Collisions.noCollisionsData',
    'errorMsgs.Collisions.errorProcessingCollisions',
    'errorMsgs.EditSat.errorReadingFile',
    'errorMsgs.EditSat.satelliteNotFound',
    'errorMsgs.CreateSat.errorCreatingSat',
    'errorMsgs.Reports.popupBlocker',
    'errorMsgs.SensorManager.errorUpdatingUi',
    'hoverManager.launched',
    'hoverManager.launchedPlanned',
    'hoverManager.launchedUnknown',
    'darkClouds.in',
    'darkClouds.satellites',
    'darkClouds.and',
    'darkClouds.debris',
    'darkClouds.buildingBuffers',
    'darkClouds.presentDay',
    'filterMenu.payloads.name',
    'filterMenu.payloads.category',
    'filterMenu.payloads.tooltip',
    'filterMenu.rocketBodies.name',
    'filterMenu.rocketBodies.category',
    'filterMenu.rocketBodies.tooltip',
    'filterMenu.debris.name',
    'filterMenu.debris.category',
    'filterMenu.debris.tooltip',
    'filterMenu.unknownType.name',
    'filterMenu.unknownType.category',
    'filterMenu.unknownType.tooltip',
    'filterMenu.notionalSatellites.name',
    'filterMenu.notionalSatellites.category',
    'filterMenu.notionalSatellites.tooltip',
    'filterMenu.agencies.name',
    'filterMenu.agencies.category',
    'filterMenu.agencies.tooltip',
    'filterMenu.agencies.checked',
    'filterMenu.agencies.disabled',
    'filterMenu.vleoSatellites.name',
    'filterMenu.vleoSatellites.category',
    'filterMenu.vleoSatellites.tooltip',
    'filterMenu.leoSatellites.name',
    'filterMenu.leoSatellites.category',
    'filterMenu.leoSatellites.tooltip',
    'filterMenu.heoSatellites.name',
    'filterMenu.heoSatellites.category',
    'filterMenu.heoSatellites.tooltip',
    'filterMenu.meoSatellites.name',
    'filterMenu.meoSatellites.category',
    'filterMenu.meoSatellites.tooltip',
    'filterMenu.geoSatellites.name',
    'filterMenu.geoSatellites.category',
    'filterMenu.geoSatellites.tooltip',
    'filterMenu.xgeoSatellites.name',
    'filterMenu.xgeoSatellites.category',
    'filterMenu.xgeoSatellites.tooltip',
    'filterMenu.vimpelSatellites.name',
    'filterMenu.vimpelSatellites.category',
    'filterMenu.vimpelSatellites.tooltip',
    'filterMenu.celestrakSatellites.name',
    'filterMenu.celestrakSatellites.category',
    'filterMenu.celestrakSatellites.tooltip',
    'satInfoBox.title',
    'satInfoBox.Cospar.label',
    'satInfoBox.Cospar.tooltip',
    'satInfoBox.Norad.label',
    'satInfoBox.Norad.tooltip',
    'satInfoBox.AltName.label',
    'satInfoBox.AltName.tooltip',
    'satInfoBox.AltId.label',
    'satInfoBox.AltId.tooltip',
    'satInfoBox.Source.label',
    'satInfoBox.Source.tooltip',
    'satInfoBox.Confidence.label',
    'satInfoBox.Confidence.tooltip',
    'SatInfoBoxObject.title',
    'SatInfoBoxObject.Type.label',
    'SatInfoBoxObject.Type.tooltip',
    'SatInfoBoxObject.Type.unknown',
    'SatInfoBoxObject.Type.payload',
    'SatInfoBoxObject.Type.rocketBody',
    'SatInfoBoxObject.Type.debris',
    'SatInfoBoxObject.Type.special',
    'SatInfoBoxObject.Type.missile',
    'SatInfoBoxObject.Status.label',
    'SatInfoBoxObject.Status.tooltip',
    'SatInfoBoxObject.Status.operational',
    'SatInfoBoxObject.Status.nonOperational',
    'SatInfoBoxObject.Status.partiallyOperational',
    'SatInfoBoxObject.Status.extendedMission',
    'SatInfoBoxObject.Status.backupStandby',
    'SatInfoBoxObject.Status.spare',
    'SatInfoBoxObject.Status.unknown',
    'SatInfoBoxObject.Country.label',
    'SatInfoBoxObject.Country.tooltip',
    'SatInfoBoxObject.LaunchSite.label',
    'SatInfoBoxObject.LaunchSite.tooltip',
    'SatInfoBoxObject.LaunchVehicle.label',
    'SatInfoBoxObject.LaunchVehicle.tooltip',
    'SatInfoBoxObject.Configuration.label',
    'SatInfoBoxObject.Configuration.tooltip',
    'SatInfoBoxObject.RCS.label',
    'SatInfoBoxObject.RCS.tooltip',
    'SatInfoBoxObject.StdMag.label',
    'SatInfoBoxObject.StdMag.tooltip',
    'SatInfoBoxObject.unknown',
    'SatInfoBoxManeuver.noEventDetected',
    'SatInfoBoxManeuver.orbitOutOfFamily',
    'SatInfoBoxManeuver.stabilityChange',
    'SatInfoBoxOrbital.title',
    'SatInfoBoxOrbital.Apogee.label',
    'SatInfoBoxOrbital.Apogee.tooltip',
    'SatInfoBoxOrbital.Perigee.label',
    'SatInfoBoxOrbital.Perigee.tooltip',
    'SatInfoBoxOrbital.Inclination.label',
    'SatInfoBoxOrbital.Inclination.tooltip',
    'SatInfoBoxOrbital.Eccentricity.label',
    'SatInfoBoxOrbital.Eccentricity.tooltip',
    'SatInfoBoxOrbital.RightAsc.label',
    'SatInfoBoxOrbital.RightAsc.tooltip',
    'SatInfoBoxOrbital.ArgOfPerigee.label',
    'SatInfoBoxOrbital.ArgOfPerigee.tooltip',
    'SatInfoBoxOrbital.Latitude.label',
    'SatInfoBoxOrbital.Latitude.tooltip',
    'SatInfoBoxOrbital.Latitude.north',
    'SatInfoBoxOrbital.Latitude.south',
    'SatInfoBoxOrbital.Longitude.label',
    'SatInfoBoxOrbital.Longitude.tooltip',
    'SatInfoBoxOrbital.Longitude.east',
    'SatInfoBoxOrbital.Longitude.west',
    'SatInfoBoxOrbital.Altitude.label',
    'SatInfoBoxOrbital.Altitude.tooltip',
    'SatInfoBoxOrbital.Period.label',
    'SatInfoBoxOrbital.Period.tooltip',
    'SatInfoBoxOrbital.Period.meanMotion',
    'SatInfoBoxOrbital.Period.revPerDay',
    'SatInfoBoxOrbital.Period.min',
    'SatInfoBoxOrbital.Velocity.label',
    'SatInfoBoxOrbital.Velocity.tooltip',
    'SatInfoBoxOrbital.AgeOfGP.label',
    'SatInfoBoxOrbital.AgeOfGP.tooltip',
    'SatInfoBoxOrbital.AgeOfGP.days',
    'SatInfoBoxOrbital.AgeOfGP.hours',
    'SatInfoBoxOrbital.AgeOfGP.epochYear',
    'SatInfoBoxOrbital.AgeOfGP.epochDay',
    'SatInfoBoxOrbital.RadialSigma.label',
    'SatInfoBoxOrbital.RadialSigma.tooltip',
    'SatInfoBoxOrbital.InTrackSigma.label',
    'SatInfoBoxOrbital.InTrackSigma.tooltip',
    'SatInfoBoxOrbital.CrossTrackSigma.label',
    'SatInfoBoxOrbital.CrossTrackSigma.tooltip',
    'SatInfoBoxOrbital.meter',
    'SatInfoBoxOrbital.kilometer',
    'SatInfoBoxOrbital.second',
    'SatInfoBoxOrbital.unknown',
    'SatInfoBoxActions.title',
    'SatInfoBoxActions.tooltip',
    'SatInfoBoxActions.DrawLine.sunAngle',
    'SatInfoBoxActions.DrawLine.RicLine.label',
    'SatInfoBoxActions.DrawLine.RicLine.tooltip',
    'SatInfoBoxActions.DrawLine.nadirLine',
    'SatInfoBoxActions.DrawLine.secLine',
    'SatInfoBoxActions.SearchLinks.LaunchObjects.label',
    'SatInfoBoxActions.SearchLinks.LaunchObjects.tooltip',
    'SatInfoBoxActions.SearchLinks.nearOrbits.label',
    'SatInfoBoxActions.SearchLinks.nearOrbits.tooltip',
    'SatInfoBoxActions.SearchLinks.nearObjects1.label',
    'SatInfoBoxActions.SearchLinks.nearObjects1.tooltip',
    'SatInfoBoxActions.SearchLinks.nearObjects2.label',
    'SatInfoBoxActions.SearchLinks.nearObjects2.tooltip',
    'SatInfoBoxActions.SearchLinks.nearObjects4.label',
    'SatInfoBoxActions.SearchLinks.nearObjects4.tooltip',
    'SatInfoBoxActions.noSatelliteSelected',
    'SatInfoBoxActions.noSecondarySatelliteSelected',
    'SatInfoBoxLinks.title',
    'SatInfoBoxLinks.tooltip',
    'SatInfoBoxLinks.Celestrak.link',
    'SatInfoBoxLinks.Celestrak.title',
    'SatInfoBoxLinks.Kayhan.link',
    'SatInfoBoxLinks.N2YO.link',
    'SatInfoBoxLinks.N2YO.title',
    'SatInfoBoxLinks.Heavens_Above.link',
    'SatInfoBoxLinks.Heavens_Above.title',
    'SatInfoBoxLinks.notASatellite',
    'SatInfoBoxMission.title',
    'SatInfoBoxMission.Mission.label',
    'SatInfoBoxMission.Mission.tooltip',
    'SatInfoBoxMission.User.label',
    'SatInfoBoxMission.User.tooltip',
    'SatInfoBoxMission.Purpose.label',
    'SatInfoBoxMission.Purpose.tooltip',
    'SatInfoBoxMission.Contractor.label',
    'SatInfoBoxMission.Contractor.tooltip',
    'SatInfoBoxMission.LiftMass.label',
    'SatInfoBoxMission.LiftMass.tooltip',
    'SatInfoBoxMission.DryMass.label',
    'SatInfoBoxMission.DryMass.tooltip',
    'SatInfoBoxMission.LifeExpectancy.label',
    'SatInfoBoxMission.LifeExpectancy.tooltip',
    'SatInfoBoxMission.Bus.label',
    'SatInfoBoxMission.Bus.tooltip',
    'SatInfoBoxMission.Payload.label',
    'SatInfoBoxMission.Payload.tooltip',
    'SatInfoBoxMission.Equipment.label',
    'SatInfoBoxMission.Equipment.tooltip',
    'SatInfoBoxMission.Motor.label',
    'SatInfoBoxMission.Motor.tooltip',
    'SatInfoBoxMission.Length.label',
    'SatInfoBoxMission.Length.tooltip',
    'SatInfoBoxMission.Diameter.label',
    'SatInfoBoxMission.Diameter.tooltip',
    'SatInfoBoxMission.Span.label',
    'SatInfoBoxMission.Span.tooltip',
    'SatInfoBoxMission.Shape.label',
    'SatInfoBoxMission.Shape.tooltip',
    'SatInfoBoxMission.Power.label',
    'SatInfoBoxMission.Power.tooltip',
    'SatInfoBoxMission.missingElements',
    'SatInfoBoxMission.kg',
    'SatInfoBoxMission.m',
    'SatInfoBoxMission.w',
    'SatInfoBoxMission.yrs',
    'SatInfoBoxMission.unknown',
    'SatInfoBoxMission.noData',
];
const translationCache = new Map();
/**
 * Translates a given key into the corresponding localized string.
 * The name t7e represents t + 7 + e, where 7 is the number of letters in the word "translate".
 *
 * @param key - The translation key to be localized. This should correspond to a valid key in the translation files.
 * @param options - An optional object containing variables to interpolate into the localized string.
 * @returns The localized string corresponding to the provided key. If no localization is found, the key itself is returned.
 *
 * @remarks
 * This function is a placeholder and should be replaced with the actual `t7e` integration
 * or another localization library implementation.
 */
export function t7e(key, options) {
    // Check if the translation is already cached
    if (translationCache.has(key)) {
        return translationCache.get(key);
    }
    // Perform the translation using i18next
    const translatedString = i18next.t(key, options);
    // Cache the translation
    translationCache.set(key, translatedString);
    return translatedString;
}
